import React, { createContext, useContext, useState, useCallback } from "react";

const LeadDetailContext = createContext();

export const LeadDetailProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [leadId, setLeadId] = useState(null);
    const [entityName, setEntityName] = useState("Lead");
    const [additionalProps, setAdditionalProps] = useState({});

    const openLeadDetail = useCallback((id, name = "Lead", props = {}) => {
        setLeadId(id);
        setEntityName(name);
        setAdditionalProps(props);
        setIsOpen(true);
    }, []);

    const closeLeadDetail = useCallback(() => {
        setIsOpen(false);
        // Don't clear leadId immediately to prevent animation glitches
        setTimeout(() => {
            setLeadId(null);
            setAdditionalProps({});
        }, 300);
    }, []);

    return (
        <LeadDetailContext.Provider
            value={{
                isOpen,
                leadId,
                entityName,
                additionalProps,
                openLeadDetail,
                closeLeadDetail,
            }}
        >
            {children}
        </LeadDetailContext.Provider>
    );
};

export const useLeadDetail = () => {
    const context = useContext(LeadDetailContext);
    if (!context) {
        throw new Error("useLeadDetail must be used within a LeadDetailProvider");
    }
    return context;
};
